/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_UnavoidableInputs */



/**
* | output |
* | --- |
* | "(unavoidable)" |
*
* @param {Rounds_UnavoidableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_unavoidable = /** @type {((inputs?: Rounds_UnavoidableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_UnavoidableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("(inévitable)")
	if (locale === "es") return /** @type {LocalizedString} */ ("(inevitable)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("(inevitável)")
	if (locale === "it") return /** @type {LocalizedString} */ ("(inevitabile)")
	return /** @type {LocalizedString} */ ("(unavoidable)")
});